import React, { useContext } from 'react';
import { IEditCategoryContext, EditCategoryContext } from '../../../editCategoryState/editCategoryContext';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setDefaultCustomerLanguage,
		setTranslationTab,
		changeNameTranslation,
		IDSelectedCustomer,
		translations,
		selectedTranslationTab,
	} = useContext<IEditCategoryContext>(EditCategoryContext);
	return (
		<MenuTranslationForm
			setDefaultCustomerLanguage={setDefaultCustomerLanguage}
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			isVisible={isVisible}
			IDSelectedCustomer={IDSelectedCustomer}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
		/>
	);
};

export default TranslationsForm;
